// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"87a7ff78","520":"c1f1e6bf"}[chunkId] + ".chunk.js";
};